import ChildTemplate from '@template/_/ChildTemplate';

const style = document.createElement('style');
document.head.appendChild(style);

export default class extends ChildTemplate {
  agency;

  init(data) {
    this.agency = +data.AgencyId;
    this.setStyle();
  }

  setStyle() {
    let promise = Promise.resolve('');
    switch (this.agency) {
      case 302:
        promise = import('./302');
        break;
      // case 2101:
      //   promise = import('./2101');
      //   break;
      default:
        promise = Promise.resolve('');
    }
    promise.then((data) => {
      style.innerHTML = data.default || '';
    });
  }
}
